import "./sass/style.scss";

//FONT WILL NOT LOAD IN DEV LOCALHOST - dont worry, will load when put on cPanel server

import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import Helmet from "react-helmet";

import Cart from "./components/Cart";
import NavBar from "./frames/NavBar";
import Footer from "./frames/Footer";
// import Popup from './frames/Popup'

import StaticData from "./static/StaticData";
import Routes from "./static/RouteData";

import animated from "./functions/Animated";
import isMobile from "./functions/isMobile";

import createCartMutation from "./graphql/mutations/createCart.graphql";
import cartLinesAdd from "./graphql/mutations/cartLinesAdd.graphql";
import cartLinesRemove from "./graphql/mutations/cartLinesRemove.graphql";
import cartLinesUpdate from "./graphql/mutations/cartLinesUpdate.graphql";
import cartNoteUpdate from "./graphql/mutations/cartNoteUpdate.graphql";

import fetchCartQuery from "./graphql/queries/fetchCart.graphql";

// const APopup = animated(Popup, 300);
const ACart = animated(Cart, 300);
class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isCartOpen: false,
			checkout: { lines: { edges: [] } },
			// shop: {},
			haveLoaded: false,
			isM: false,
			// showPopup: false,
		};
	}

	createNewCheckout = async (lines) => {
		console.log("Creating new checkout...");
		const { data, errors, extensions } = await this.props.client.request(createCartMutation.loc.source.body, {
			variables: {
				cartInput: {
					lines,
				},
			},
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}

		// console.log("Checkout successfully created: ", JSON.stringify(data, null, 2));

		this.setState({
			checkout: data.cartCreate.cart,
		});

		console.log("try caching checkout id");
		if (typeof window === "undefined") return;

		localStorage.setItem(StaticData.getCheckoutIdKey(), data.cartCreate.cart.id);
		console.log("cached checkout id", data.cartCreate.cart.id);
		// });
	};

	fetchCheckout = async (id) => {
		const { data, errors, extensions } = await this.props.client.request(fetchCartQuery.loc.source.body, {
			variables: { id },
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}
		// console.log("Cart successfully fetched", JSON.stringify(data, null, 2));
		return data.cart;
	};

	componentDidMount() {
		console.log("try caching checkout id");
		this.setState({ isM: isMobile() });
		if (typeof window !== "undefined") {
			let checkoutId = localStorage.getItem(StaticData.getCheckoutIdKey());
			console.log("got cached checkout id", checkoutId);

			// let dontShowEmailPopup = localStorage.getItem(StaticData.getEmailPopupKey());

			if (checkoutId == null) {
				this.createNewCheckout();
			} else {
				this.fetchCheckout(checkoutId).then((res) => {
					if (res == null) {
						this.createNewCheckout();
					} else {
						this.setState({
							checkout: res,
						});
					}
				});
			}
		}
	}

	getEmailPopup = () => {
		if (typeof window === "undefined") return null;
		return (
			<APopup
				show={this.state.showPopup}
				title="join the email list? (´･ᴗ･ ` )"
				subtitle="be the first to know about sales, new items, and more!"
				content={
					<form
						className="flex-row stretch-width tiny-pad"
						onSubmit={() => localStorage.setItem(StaticData.getEmailPopupKey(), true)}
						action="https://softyshop.com/sendy/subscribe"
						method="POST"
						acceptCharset="utf-8"
					>
						<input className="stretch" type="email" name="email" id="email" placeholder="your email" style={{ marginLeft: "12px" }} />

						<input type="hidden" name="hp" id="hp" />
						<input type="hidden" name="list" value="VgS21n892B1IuYybZJnJysXw" />
						<input type="hidden" name="subform" value="yes" />

						<input className="button tinyblock-horz" type="submit" value="join" />
					</form>
				}
				storageKey={StaticData.getEmailPopupKey()}
				closePopup={() => this.setState({ showPopup: false })}
			/>
		);
	};

	addVariantToCart = async (variantId, quantity) => {
		this.setState({
			isCartOpen: true,
		});

		const lines = [
			{
				merchandiseId: variantId,
				quantity: parseInt(quantity, 10),
			},
		];

		if (this.state.checkout == null || this.state.checkout.id == null) {
			await this.createNewCheckout(lines);
		}
		// else {
		// below is copy of updateQuantityInCart
		const { data, errors, extensions } = await this.props.client.request(cartLinesAdd.loc.source.body, {
			variables: {
				cartId: this.state.checkout.id,
				lines: lines,
			},
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}

		// console.log("Cart successfully added", JSON.stringify(data, null, 2));

		this.setState({
			checkout: data.cartLinesAdd.cart,
		});
		// }
	};

	updateQuantityInCart = async (variantId, quantity) => {
		const { data, errors, extensions } = await this.props.client.request(cartLinesUpdate.loc.source.body, {
			variables: {
				cartId: this.state.checkout.id,
				lines: [
					{
						id: variantId,
						quantity: parseInt(quantity, 10),
					},
				],
			},
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}

		// console.log("Cart successfully updated", JSON.stringify(data, null, 2));

		this.setState({
			checkout: data.cartLinesUpdate.cart,
		});
	};

	removeLineItemInCart = async (variantId) => {
		const { data, errors, extensions } = await this.props.client.request(cartLinesRemove.loc.source.body, {
			variables: {
				cartId: this.state.checkout.id,
				lineIds: [variantId],
			},
		});

		if (errors) {
			console.error("error!", JSON.stringify(errors, null, 2));
			return;
		}

		// console.log("Cart successfully removed", JSON.stringify(data, null, 2));

		this.setState({
			checkout: data.cartLinesRemove.cart,
		});
	};

	updateCartNote = async (input) => {
		const { data, errors, extensions } = await this.props.client.request(cartNoteUpdate.loc.source.body, {
			variables: {
				cartId: this.state.checkout.id,
				note: input,
			},
		});

		if (errors) {
			console.error(errors.message);
			return;
		}

		let cart = this.state.checkout;
		cart.note = data.cartNoteUpdate.cart.note;
		this.setState({
			checkout: cart,
		});

		console.log("Checkout note successfully updated: ", data.cartNoteUpdate.cart.note);
	};

	handleCartClose = () => {
		this.setState({
			isCartOpen: false,
		});
	};

	getAllLink = () => {
		if (this.state.isM) return null;
		return (
			<Link to={"/products/" + StaticData.allURL} className="block-horz smblock-vert flex-row">
				<span className="bold-18">all</span>
				<span className="bold-18 tiny-block jam jam-chevron-down"></span>
			</Link>
		);
	};

	getShopLinks = () => {
		if (this.state.isM)
			return (
				<div className="flex-vertical align-stretch dropdown">
					<Link to={"/products/" + StaticData.allURL} className="dropdown-link">
						<h2>all.</h2>
					</Link>
					<Link to={"/products/" + StaticData.pinURL} className="dropdown-link">
						<h2>pins.</h2>
					</Link>
					<Link to={"/products/" + StaticData.stickerURL} className="dropdown-link">
						<h2>stickers.</h2>
					</Link>
					<Link to={"/products/" + StaticData.apparelURL} className="dropdown-link">
						<h2>apparel.</h2>
					</Link>
				</div>
			);

		return (
			<div className="flex-vertical align-stretch dropdown">
				<Link to={"/products/" + StaticData.pinURL} className="dropdown-link">
					<span className="bold-18">pins</span>
				</Link>
				<Link to={"/products/" + StaticData.stickerURL} className="dropdown-link">
					<span className="bold-18">stickers</span>
				</Link>
				<Link to={"/products/" + StaticData.apparelURL} className="dropdown-link">
					<span className="bold-18">apparel</span>
				</Link>
			</div>
		);
	};

	getHome = () => {
		return (
			<Link to="/" className="a-logo">
				<div className="logo" />
			</Link>
		);
	};

	getFooterLinks = () => {
		if (this.state.isM)
			return (
				<div className="flex-vertical relative align-start smblock-vert">
					<Link to="/about" className="block-horz eensypad-vert">
						<span className="bold-14">about</span>
					</Link>
					<Link to="/faq" className="block-horz eensypad-vert">
						<span className="bold-14">faq</span>
					</Link>
					<Link to="/contact" className="block-horz eensypad-vert">
						<span className="bold-14">contact</span>
					</Link>
				</div>
			);

		return (
			<div>
				<Link to="/about" className="block-horz">
					<span className="bold-14">about</span>
				</Link>
				<Link to="/faq" className="block-horz">
					<span className="bold-14">faq</span>
				</Link>
				<Link to="/contact" className="block-horz">
					<span className="bold-14">contact</span>
				</Link>
			</div>
		);
	};

	calculateCartQuantity = () => {
		let count = 0;
		if (this.state.checkout != null) {
			for (let item of this.state.checkout.lines.edges) {
				count += item.node.quantity;
			}
		}
		return count;
	};

	render() {
		let footer,
			appClass,
			{ isM } = this.state;

		if (isM === true) {
			footer = (
				<Switch>
					<Route path="/products/:id" render={() => <Footer isM={isM} />} />
					<Route path="/product/:id" render={() => <Footer isM={isM} />} />
				</Switch>
			);
			appClass = "App";
		} else {
			footer = <Footer isM={isM} footerLinks={this.getFooterLinks()} />;
			appClass = "App flex-vertical-stretch";
		}

		// this.printIds();

		let animateNavBar;
		if (this.state.haveLoaded) {
			animateNavBar = false;
		} else {
			animateNavBar = true;
			this.setState({ haveLoaded: true });
		}

		return (
			<div className={appClass}>
				<Helmet
					title="softy."
					meta={[
						{ property: "og:type", content: "website" },
						{ property: "og:title", content: "softy." },
						{
							property: "og:description",
							content: "merch at 2 extremes: soft and dark.",
						},
						{ property: "og:site_name", content: "softy." },

						{
							name: "keywords",
							content: "apparel, enamel pins, stickers, grunge, vaporwave, aesthetic, kstyle, cute, streetwear, anime, goth, baddie",
						},

						{ name: "twitter:card", content: "summary" },
						{ name: "twitter:title", content: "softy." },
						{
							name: "twitter:description",
							content: "at 2 extremes: soft and dark.",
						},
					]}
				/>

				<NavBar
					isM={isM}
					isCartOpen={this.state.isCartOpen}
					openCart={() => this.setState({ isCartOpen: true })}
					isAnimated={animateNavBar}
					allLink={this.getAllLink()}
					shopLinks={this.getShopLinks()}
					home={this.getHome()}
					cartItems={this.calculateCartQuantity()}
					footerLinks={this.getFooterLinks()}
				/>

				<Switch>
					{renderRoutes(Routes, {
						isM: isM,
						client: this.props.client,
						addVariantToCart: this.addVariantToCart,
					})}
				</Switch>
				{footer}
				{/* {this.getEmailPopup()} */}
				<ACart
					isM={isM}
					checkout={this.state.checkout}
					show={this.state.isCartOpen}
					handleCartClose={this.handleCartClose}
					updateCartNote={this.updateCartNote}
					updateQuantityInCart={this.updateQuantityInCart}
					removeLineItemInCart={this.removeLineItemInCart}
				/>
			</div>
		);
	}
}

export default App;
